module.exports = "\r\n\r\n.fileshare-container {\r\n    height: 100%;\r\n    padding: 1em 1.5em;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/chat/sub-components/add-files/add-files.component.css
// module id = ./src/app/pages/chat/sub-components/add-files/add-files.component.css
// module chunks = main